import React, { FunctionComponent } from 'react';
import { QaleLogo } from '@/common/components/atoms/icons';

export const FullScreenLoader: FunctionComponent = () => {
  return (
    <div className={`d-full flex items-center justify-center`}>
      <div className="flex flex-col items-center gap-4">
        <QaleLogo className="animate-pulse" style={{ maxHeight: '80px' }} />
        <div className="h-2 w-32 rounded-full bg-gray-200 overflow-hidden">
          <div className="h-full bg-primary animate-pulse" style={{ width: '60%' }}></div>
        </div>
      </div>
    </div>
  );
};
